/* ==========================================================
   Don Chacho 2.0 — Food Service · Cotizador
   - Actualiza el resumen en vivo
   - Junta los sabores elegidos en contact[Sabores]
   - Tras enviar (éxito o error) regresa la vista al formulario
   ========================================================== */
(function () {
  function iniciar(root) {
    if (!root || root.dataset.dcInit === '1') return;
    root.dataset.dcInit = '1';

    var form = root.querySelector('form');
    if (!form) return;

    var inputSabores = form.querySelector('[data-dc-sabores-input]');
    var sinSabores = root.dataset.sinSabores || '—';

    function escribir(clave, texto) {
      var el = root.querySelector('[data-dc-res="' + clave + '"]');
      if (el) el.textContent = texto;
    }

    function elegido(grupo) {
      var el = form.querySelector('input[data-dc-grupo="' + grupo + '"]:checked');
      return el ? el.value : '—';
    }

    function actualizar() {
      var sabores = Array.prototype.map.call(
        form.querySelectorAll('input[data-dc-sabor]:checked'),
        function (i) { return i.value; }
      );

      if (inputSabores) inputSabores.value = sabores.join(', ');

      escribir('tipo', elegido('tipo'));
      escribir('pres', elegido('pres'));
      escribir('vol', elegido('vol'));
      escribir('sabores', sabores.length ? sabores.join(', ') : sinSabores);
    }

    form.addEventListener('change', actualizar);
    actualizar();

    // Después de enviar, Shopify recarga la página: llevamos al usuario al mensaje
    if (root.querySelector('.dc-fs-cot__exito, .dc-fs-cot__errores')) {
      var destino = root.querySelector('.dc-fs-cot__resumen') || root;
      setTimeout(function () {
        destino.scrollIntoView({ block: 'center' });
      }, 150);
    }
  }

  function arrancar() {
    document.querySelectorAll('.dc-fs-cot').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // Editor de temas: re-inicia cuando la sección se recarga
  document.addEventListener('shopify:section:load', function (e) {
    iniciar(e.target.querySelector('.dc-fs-cot'));
  });
})();